import Validator from 'validator';
import isEmpty from 'lodash/isEmpty';

export default function giftCardValidator(data) {
  let errors = {};

  if (Validator.isNull(data.email)) {
    errors.email = "Este campo é obrigatório!";
  }

  if (!Validator.isEmail(data.email)) {
    errors.email = "O email é inválido";
  }

  if (Validator.isNull(data.name)) {
    errors.name = "Este campo é obrigatório!";
  }

  if (Validator.isNull(data.subject)) {
    errors.subject = "Este campo é obrigatório!";
  }

  if (Validator.isNull(data.message)) {
    errors.message = "Este campo é obrigatório!";
  }

  if (Validator.isNull(data.recaptcha)) {
    errors.recaptcha = "Este campo é obrigatório!";
  }

  return {
    errors,
    isValid: isEmpty(errors)
  }
}



// WEBPACK FOOTER //
// ./src/components/validations/messageValidator.js